const StepGroupType = {
  Modals: 'modals',
  Slideouts: 'slideouts',
  Tooltips: 'tooltips',
  Hotspots: 'hotspots',
  Actions: 'actions',
};

export const USER_LIFECYCLE_STAGE = {
  EXPLORERS: 'explorers',
  BEGINNERS: 'beginners',
  REGULARS: 'regulars',
  CHAMPIONS: 'champions',
};

export const PRODUCT_LED_FLOWS = [
  {
    name: 'Welcome to the family',
    description: 'Greet new users with an overview of your app.',
    userLifecycleStage: USER_LIFECYCLE_STAGE.EXPLORERS,
    screenshotUrl:
      'https://res.cloudinary.com/dnjrorsut/image/upload/v1561052913/reactcues-assets/Evaluator_1.png',
    gradient:
      'linear-gradient(90deg, rgba(11, 182, 217, 0.3) 0%, rgba(16, 213, 203, 0.3) 100%)',
    steps: {
      0: {
        backdrop: true,
        description: '',
        index: 0,
        legacyStepType: 'flow',
        name: '',
        patternType: 'modal',
        published: false,
        sandbox: true,
        skippable: true,
        state: 'DRAFT',
        stepType: 'modal',
        stepGroupType: StepGroupType.Modals,
        steps: {
          0: {
            content:
              '<div class="canvas"> <div class="row-container"> <div class="row" style="display: inline-block; width: 100%"> <div class="zone-container" style="display: inline-block; width: 100%; float: left;"> <div class="zone"> <div class="zone-content"> <div class="hero apc-hero" style="min-height:286px;background-size:cover;text-align:center;background-image:url(//res.cloudinary.com/dnjrorsut/image/upload/v1560955745/sample/arh62l63izexihbl1el3.jpg);"><div class="hero-content"><h1></h1></div></div> </div> </div> </div> </div> </div> <div class="row-container"> <div class="row" style="display: inline-block; width: 100%"> <div class="zone-container" style="display: inline-block; width: 100%; float: left;"> <div class="zone"> <div class="zone-content"> <div class="rich-text" style="margin-top:20px;"><style>.rich-text strong{color:inherit !important;}</style><div><h2 style="text-align:center"><strong>{{ First Name | &quot;Hey there&quot; }}, </strong></h2><h2 style="text-align:center"><strong>welcome to the family!</strong></h2><p style="text-align:center"><span style="color:rgb(54, 71, 96)">We&#x27;re excited to have you on</span><span style="color:#364760"> </span><span style="color:rgb(54, 71, 96)">board. Follow along for a quick tour of what makes us special.</span></p></div></div> </div> </div> </div> </div> </div> </div>',
            index: 0,
            isButtonCentered: true,
            nextText: 'Ok, got it',
            prevText: 'Back',
            rows: [
              {
                id: '82042e44-7dfd-402e-9ab6-bd280fe0e44a',
                zones: [
                  {
                    id: '8e271771-70a7-4cf1-b543-0a41cf0524b1',
                    persistedState: {
                      backgroundType: 'url',
                      content: '<h1></h1>',
                      minHeight: 286,
                      textAlign: 'center',
                      url: '//res.cloudinary.com/dnjrorsut/image/upload/v1560955745/sample/arh62l63izexihbl1el3.jpg',
                      width: 1613,
                      zoom: '',
                    },
                    type: 'Hero',
                  },
                ],
              },
              {
                id: '62aa82ad-6d67-43e3-b7b0-91fe6ee11f62',
                zones: [
                  {
                    id: 'd66c4f36-eeed-4709-b1f4-84fe17165a30',
                    persistedState: {
                      content:
                        '<h2 style="text-align:center"><strong>{{ First Name | &quot;Hey there&quot; }}, </strong></h2><h2 style="text-align:center"><strong>welcome to the family!</strong></h2><p style="text-align:center"><span style="color:rgb(54, 71, 96)">We&#x27;re excited to have you on</span><span style="color:#364760"> </span><span style="color:rgb(54, 71, 96)">board. Follow along for a quick tour of what makes us special.</span></p>',
                      marginTop: 20,
                    },
                    type: 'RichText',
                  },
                ],
              },
            ],
            stepNumber: 1,
            stepType: 'components',
          },
          1: {
            actionsHidden: false,
            content:
              '<div class="canvas"> <div class="row-container"> <div class="row" style="display: inline-block; width: 100%"> <div class="zone-container" style="display: inline-block; width: 100%; float: left;"> <div class="zone"> <div class="zone-content"> <div class="hero apc-hero" style="min-height:286px;background-size:cover;text-align:center;background-image:url(//res.cloudinary.com/dnjrorsut/image/upload/v1560955998/sample/xtpjxsack5pi92yben2f.jpg);"><div class="hero-content"><h1></h1></div></div> </div> </div> </div> </div> </div> <div class="row-container"> <div class="row" style="display: inline-block; width: 100%"> <div class="zone-container" style="display: inline-block; width: 100%; float: left;"> <div class="zone"> <div class="zone-content"> <div class="rich-text" style="margin-top:20px;"><style>.rich-text strong{color:inherit !important;}</style><div><h2 style="text-align:center"><strong>We make collaboration easier than ever!</strong></h2><p style="text-align:center"><span style="color:rgb(54, 71, 96)">Streamline your workflow with fast and easy commenting and approvals.</span></p></div></div> </div> </div> </div> </div> </div> </div>',
            index: 1,
            isButtonCentered: false,
            nextText: 'Next',
            prevButtonHidden: false,
            prevText: 'Back',
            rows: [
              {
                id: '82042e44-7dfd-402e-9ab6-bd280fe0e44a',
                zones: [
                  {
                    id: '8e271771-70a7-4cf1-b543-0a41cf0524b1',
                    persistedState: {
                      backgroundType: 'url',
                      content: '<h1></h1>',
                      minHeight: 286,
                      textAlign: 'center',
                      url: '//res.cloudinary.com/dnjrorsut/image/upload/v1560955998/sample/xtpjxsack5pi92yben2f.jpg',
                      width: 1613,
                      zoom: '',
                    },
                    type: 'Hero',
                  },
                ],
              },
              {
                id: '62aa82ad-6d67-43e3-b7b0-91fe6ee11f62',
                zones: [
                  {
                    id: 'd66c4f36-eeed-4709-b1f4-84fe17165a30',
                    persistedState: {
                      content:
                        '<h2 style="text-align:center"><strong>We make collaboration easier than ever!</strong></h2><p style="text-align:center"><span style="color:rgb(54, 71, 96)">Streamline your workflow with fast and easy commenting and approvals.</span></p>',
                      marginTop: 20,
                    },
                    type: 'RichText',
                  },
                ],
              },
            ],
            stepNumber: 2,
            stepType: 'components',
          },
          2: {
            actionsHidden: false,
            content:
              '<div class="canvas"> <div class="row-container"> <div class="row" style="display: inline-block; width: 100%"> <div class="zone-container" style="display: inline-block; width: 100%; float: left;"> <div class="zone"> <div class="zone-content"> <div class="hero apc-hero" style="min-height:286px;background-size:cover;text-align:center;background-image:url(//res.cloudinary.com/dnjrorsut/image/upload/v1560956352/sample/mert4kdipl9ervyt91np.jpg);"><div class="hero-content"><h1></h1></div></div> </div> </div> </div> </div> </div> <div class="row-container"> <div class="row" style="display: inline-block; width: 100%"> <div class="zone-container" style="display: inline-block; width: 100%; float: left;"> <div class="zone"> <div class="zone-content"> <div class="rich-text" style="margin-top:20px;"><style>.rich-text strong{color:inherit !important;}</style><div><h2 style="text-align:center"><strong>Predictive analytics at your fingertips! </strong></h2><p style="text-align:center"><span style="color:rgb(54, 71, 96)">Analyze workplace performance with the power of predictive forecasting.</span></p></div></div> </div> </div> </div> </div> </div> </div>',
            index: 2,
            isButtonCentered: false,
            nextText: 'Done',
            prevButtonHidden: false,
            prevText: 'Back',
            rows: [
              {
                id: '82042e44-7dfd-402e-9ab6-bd280fe0e44a',
                zones: [
                  {
                    id: '8e271771-70a7-4cf1-b543-0a41cf0524b1',
                    persistedState: {
                      backgroundType: 'url',
                      content: '<h1></h1>',
                      minHeight: 286,
                      textAlign: 'center',
                      url: '//res.cloudinary.com/dnjrorsut/image/upload/v1560956352/sample/mert4kdipl9ervyt91np.jpg',
                      width: 1613,
                      zoom: '',
                    },
                    type: 'Hero',
                  },
                ],
              },
              {
                id: '62aa82ad-6d67-43e3-b7b0-91fe6ee11f62',
                zones: [
                  {
                    id: 'd66c4f36-eeed-4709-b1f4-84fe17165a30',
                    persistedState: {
                      content:
                        '<h2 style="text-align:center"><strong>Predictive analytics at your fingertips! </strong></h2><p style="text-align:center"><span style="color:rgb(54, 71, 96)">Analyze workplace performance with the power of predictive forecasting.</span></p>',
                      marginTop: 20,
                    },
                    type: 'RichText',
                  },
                ],
              },
            ],
            stepNumber: 3,
            stepType: 'components',
          },
          3: {
            actionsHidden: false,
            content:
              '<div class="canvas"> <div class="row-container"> <div class="row" style="display: inline-block; width: 100%"> <div class="zone-container" style="display: inline-block; width: 100%; float: left;"> <div class="zone"> <div class="zone-content"> <div class="hero apc-hero" style="min-height:286px;background-size:cover;text-align:center;background-image:url(//res.cloudinary.com/dnjrorsut/image/upload/v1562611046/sample/etmam5dldb3h7ik3sftw.jpg);"><div class="hero-content"><h1></h1></div></div> </div> </div> </div> </div> </div> <div class="row-container"> <div class="row" style="display: inline-block; width: 100%"> <div class="zone-container" style="display: inline-block; width: 100%; float: left;"> <div class="zone"> <div class="zone-content"> <div class="rich-text" style="margin-top:20px;"><style>.rich-text strong{color:inherit !important;}</style><div><h2 style="text-align:center"><strong>Let&#x27;s go!</strong></h2><p style="text-align:center"><span style="color:#364760">Now it&#x27;s your turn to explore. We&#x27;re here if you need us!</span></p></div></div> </div> </div> </div> </div> </div> </div>',
            index: 3,
            isButtonCentered: false,
            nextText: 'Done',
            prevButtonHidden: false,
            prevText: 'Back',
            rows: [
              {
                id: '97cfc514-00d0-4d3c-9e38-deed16f13ccd',
                zones: [
                  {
                    id: 'e538dc15-695c-424d-bf1e-fa666d26470a',
                    persistedState: {
                      backgroundType: 'url',
                      content: '<h1></h1>',
                      minHeight: 286,
                      textAlign: 'center',
                      url: '//res.cloudinary.com/dnjrorsut/image/upload/v1562611046/sample/etmam5dldb3h7ik3sftw.jpg',
                      width: 819,
                      zoom: '',
                    },
                    type: 'Hero',
                  },
                ],
              },
              {
                id: 'f06ac5b7-4699-4f1b-b445-2e94a31180c8',
                zones: [
                  {
                    id: 'c5a44c87-f3f3-4a2b-946d-f7ea242d8ec1',
                    persistedState: {
                      content:
                        '<h2 style="text-align:center"><strong>Let&#x27;s go!</strong></h2><p style="text-align:center"><span style="color:#364760">Now it&#x27;s your turn to explore. We&#x27;re here if you need us!</span></p>',
                      marginTop: 20,
                    },
                    type: 'RichText',
                  },
                ],
              },
            ],
            stepNumber: 4,
            stepType: 'components',
          },
        },
      },
    },
  },
  {
    name: 'Webinar promotion',
    description: 'Keep engaged users informed with resources.',
    userLifecycleStage: USER_LIFECYCLE_STAGE.BEGINNERS,
    screenshotUrl:
      'https://res.cloudinary.com/dnjrorsut/image/upload/v1561052913/reactcues-assets/Beginner_1.png',
    gradient:
      'linear-gradient(90deg, rgba(73, 128, 255, 0.3) 0%, rgba(46, 177, 255, 0.3) 100%)',
    steps: {
      0: {
        backdrop: false,
        description: '',
        index: 0,
        legacyStepType: 'flow',
        name: '',
        patternType: 'shorty',
        position: 'bottomLeft',
        published: false,
        sandbox: true,
        skippable: true,
        state: 'DRAFT',
        stepType: 'shorty',
        stepGroupType: StepGroupType.Slideouts,
        steps: {
          0: {
            actionsHidden: true,
            content:
              '<div class="canvas"> <div class="row-container"> <div class="row" style="display: inline-block; width: 100%"> <div class="zone-container" style="display: inline-block; width: 100%; float: left;"> <div class="zone"> <div class="zone-content"> <div class="image" style="text-align:center;"><img src="//res.cloudinary.com/dnjrorsut/image/upload/v1561040217/sample/s4mxk3rpewjr0whfginz.png" style=" width: 292px"/></div> </div> </div> </div> </div> </div> <div class="row-container"> <div class="row" style="display: inline-block; width: 100%"> <div class="zone-container" style="display: inline-block; width: 100%; float: left;"> <div class="zone"> <div class="zone-content"> <div class="rich-text"><style>.rich-text strong{color:inherit !important;}</style><div><h3 style="text-align:center"><span style="color:rgb(124, 124, 124)"><strong>Upcoming Webinar</strong></span></h3><h2 style="text-align:center"><strong>Schedule better meetings!</strong></h2></div></div> </div> </div> </div> </div> </div> <div class="row-container"> <div class="row" style="display: inline-block; width: 100%"> <div class="zone-container" style="display: inline-block; width: 100%; float: left;"> <div class="zone"> <div class="zone-content"> <div class="rich-text"><style>.rich-text strong{color:inherit !important;}</style><div><p style="text-align:center">Join us for an upcoming webinar on scheduling meetings that rock!</p><p style="text-align:center"><strong>February 18, 2021  @  9:30 AM EST</strong></p></div></div> </div> </div> </div> </div> </div> <div class="row-container"> <div class="row" style="display: inline-block; width: 100%"> <div class="zone-container" style="display: inline-block; width: 100%; float: left;"> <div class="zone"> <div class="zone-content"> <div class="button-wrapper appcues-actions-right appcues-actions-left" style="width:100%;textAlign:center;marginTop:5px;marginBottom:5px;"><style>.button-wrapper>[data-step=prev]::before {content: none} .button-wrapper>.appcues-button[data-step=next]::after {content: none}</style><a class="appcues-button-success appcues-button" data-field-id="ffe87115-0491-4988-b6cf-df76697b6cb7" style="text-align:center;padding:8px 18px;" data-step="next">Register!</a></div> </div> </div> </div> </div> </div> </div>',
            index: 0,
            isButtonCentered: true,
            nextButtonHidden: true,
            nextText: 'Register!',
            prevButtonHidden: true,
            prevText: 'Back',
            rows: [
              {
                id: '96dc4751-2d4f-4b4e-9f79-41f13367dcc5',
                zones: [
                  {
                    id: '2b3e61f6-f4ef-42dc-be84-43f3ab9f0f13',
                    persistedState: {
                      textAlign: 'center',
                      url: '//res.cloudinary.com/dnjrorsut/image/upload/v1561040217/sample/s4mxk3rpewjr0whfginz.png',
                      width: 552,
                      widthOverride: 292,
                      zoom: '',
                    },
                    type: 'Image',
                  },
                ],
              },
              {
                id: 'b1a2d02b-7288-4a20-9ab5-e1839d2061c8',
                zones: [
                  {
                    id: '6a627d66-4bd0-4161-a312-91b1b8fa7d03',
                    persistedState: {
                      content:
                        '<h3 style="text-align:center"><span style="color:rgb(124, 124, 124)"><strong>Upcoming Webinar</strong></span></h3><h2 style="text-align:center"><strong>Schedule better meetings!</strong></h2>',
                    },
                    type: 'RichText',
                  },
                ],
              },
              {
                id: '824a690a-bae9-41e6-8fbb-b1bc6f191f6d',
                zones: [
                  {
                    id: '0a3f12b6-d598-42e8-89e7-30405d852ff0',
                    persistedState: {
                      content:
                        '<p style="text-align:center">Join us for an upcoming webinar on scheduling meetings that rock!</p><p style="text-align:center"><strong>February 18, 2021  @  9:30 AM EST</strong></p>',
                    },
                    type: 'RichText',
                  },
                ],
              },
              {
                id: '0f813278-3492-4cf5-a0ee-800a87024158',
                zones: [
                  {
                    id: 'ffe87115-0491-4988-b6cf-df76697b6cb7',
                    persistedState: {
                      buttonActionType: 'next',
                      buttonText: 'Register!',
                      marginBottom: 5,
                      marginTop: 5,
                    },
                    type: 'Button',
                  },
                ],
              },
            ],
            stepNumber: 1,
            stepType: 'components',
          },
        },
      },
    },
  },
  {
    name: 'New feature release',
    description: 'Point out a new feature with a slideout and tooltip.',
    userLifecycleStage: USER_LIFECYCLE_STAGE.REGULARS,
    screenshotUrl:
      'https://res.cloudinary.com/dnjrorsut/image/upload/v1561052913/reactcues-assets/Regular_1.png',
    gradient:
      'linear-gradient(90deg, rgba(92, 92, 255, 0.3) 0%, rgba(137, 96, 255, 0.3) 100%)',
    steps: {
      0: {
        backdrop: false,
        description: '',
        index: 0,
        legacyStepType: 'flow',
        name: '',
        patternType: 'shorty',
        position: 'bottomLeft',
        published: false,
        sandbox: true,
        skippable: true,
        state: 'DRAFT',
        stepType: 'shorty',
        stepGroupType: StepGroupType.Slideouts,
        steps: {
          0: {
            content:
              '<div class="canvas"> <div class="row-container"> <div class="row" style="display: inline-block; width: 100%"> <div class="zone-container" style="display: inline-block; width: 100%; float: left;"> <div class="zone"> <div class="zone-content"> <div class="hero apc-hero" style="min-height:280px;background-size:100%;text-align:center;background-image:url(//res.cloudinary.com/dnjrorsut/image/upload/v1561040255/sample/z7dp3qmtnqn8rqgeeoii.png);"><div class="hero-content"><h1></h1></div></div> </div> </div> </div> </div> </div> <div class="row-container"> <div class="row" style="display: inline-block; width: 100%"> <div class="zone-container" style="display: inline-block; width: 100%; float: left;"> <div class="zone"> <div class="zone-content"> <div class="rich-text" style="margin-top:20px;"><style>.rich-text strong{color:inherit !important;}</style><div><h3 style="text-align:center"><strong><span style="color:rgb(124, 124, 124)">New feature!</span></strong></h3><h2 style="text-align:center"><strong>Category filters</strong></h2><p style="text-align:center">We’re proud to announce new category filters! Find and sort your meetings by category type.</p></div></div> </div> </div> </div> </div> </div> </div>',
            index: 0,
            isButtonCentered: true,
            nextText: 'Try it out!',
            prevText: 'Back',
            rows: [
              {
                id: '47699968-6fa3-4afa-b49d-cb0382f34e0a',
                zones: [
                  {
                    id: 'fe5774bc-deb2-40fd-96c9-e07a8a1bdd23',
                    persistedState: {
                      backgroundType: 'url',
                      content: '<h1></h1>',
                      minHeight: 280,
                      textAlign: 'center',
                      url: '//res.cloudinary.com/dnjrorsut/image/upload/v1561040255/sample/z7dp3qmtnqn8rqgeeoii.png',
                      width: 552,
                      widthOverride: 292,
                      zoom: 100,
                    },
                    type: 'Hero',
                  },
                ],
              },
              {
                id: '1aabf38b-d8e9-4f2f-bdb1-3a7daad041c1',
                zones: [
                  {
                    id: '58f72dc7-ff96-442e-9afa-7e2783f6100d',
                    persistedState: {
                      content:
                        '<h3 style="text-align:center"><strong><span style="color:rgb(124, 124, 124)">New feature!</span></strong></h3><h2 style="text-align:center"><strong>Category filters</strong></h2><p style="text-align:center">We’re proud to announce new category filters! Find and sort your meetings by category type.</p>',
                      marginTop: 20,
                    },
                    type: 'RichText',
                  },
                ],
              },
            ],
            stepNumber: 1,
            stepType: 'components',
          },
        },
      },
      1: {
        backdrop: false,
        backdropSolidEdge: false,
        backdropSolidEdgeOpacity: 0.5,
        beaconStyle: 'hidden',
        createdAt: 1560959521062,
        createdBy: 'fc542fd7-e9e4-49d0-8123-78040aa17e33',
        description: '',
        index: 1,
        legacyStepType: 'hotspot-group',
        name: '',
        patternType: 'tooltip-group',
        published: false,
        sequential: true,
        skippable: true,
        skippableDisplayType: 'exit-symbol',
        state: 'DRAFT',
        stepType: 'tooltip-group',
        stepGroupType: StepGroupType.Tooltips,
        hotspots: {
          0: {
            _uiNextCondition: 'this_element_clicked',
            autoSelector: '.FPdoLc center',
            backdropSolidEdgeBorderRadius: 0,
            backdropSolidEdgeXPadding: 0,
            backdropSolidEdgeYPadding: 0,
            content:
              '<div class="canvas"> <div class="row-container"> <div class="row" style="display: inline-block; width: 100%"> <div class="zone-container" style="display: inline-block; width: 100%; float: left;"> <div class="zone"> <div class="zone-content"> <div class="rich-text"><style>.rich-text strong{color:inherit !important;}</style><div><h3>Filter by category here</h3></div></div> </div> </div> </div> </div> </div> <div class="row-container"> <div class="row" style="display: inline-block; width: 100%"> <div class="zone-container" style="display: inline-block; width: 100%; float: left;"> <div class="zone"> <div class="zone-content"> <div class="rich-text"><style>.rich-text strong{color:inherit !important;}</style><div><p>Select a category from the dropdown to get started.</p></div></div> </div> </div> </div> </div> </div> </div>',
            event: 'click',
            expanded: true,
            hideNextButton: true,
            id: '-LhkR01N2McjsYveZ6Xv',
            includeOrderedMatchSelector: false,
            includeTextMatchSelector: false,
            index: 0,
            isLastHotspot: true,
            nextText: 'Close',
            offsetXPercentage: '0.3879',
            offsetYPercentage: '-0.0690',
            patternType: 'beacon',
            rows: [
              {
                id: '09c58a77-57f8-4f7d-8533-f4ec25b017fe',
                zones: [
                  {
                    id: '392a23a1-3a1b-481e-b2fe-1412f56af619',
                    persistedState: {
                      content: '<h3>Filter by category here</h3>',
                    },
                    type: 'RichText',
                  },
                ],
              },
              {
                id: '7bb04bb1-4ca2-4da7-8472-137ff791c478',
                zones: [
                  {
                    id: '991942a1-f7a5-438b-9a4b-559b71163199',
                    persistedState: {
                      content:
                        '<p>Select a category from the dropdown to get started.</p>',
                    },
                    type: 'RichText',
                  },
                ],
              },
            ],
            selector: '.FPdoLc center',
            selectorOptions: {
              tagName: ['CENTER'],
            },
            selectorSettings: {
              selector: '.FPdoLc center',
            },
            selectorTextValue: '',
            skipText: 'Hide these tips',
            skippable: true,
            skippableDisplayType: 'exit-symbol',
            stepNumber: 1,
            stepType: 'components',
            uiConditions: {
              next: {
                params: {
                  event: 'click',
                  selector: [
                    {
                      selector: '.FPdoLc center',
                    },
                  ],
                },
                type: 'WAIT_FOR_MOUSE_EVENT',
              },
            },
            wasPositionedByTargetingInterface: true,
          },
        },
      },
    },
  },
  {
    name: 'Spread the word',
    description: 'Ask loyal users to spread their love on Twitter.',
    userLifecycleStage: USER_LIFECYCLE_STAGE.CHAMPIONS,
    screenshotUrl:
      'https://res.cloudinary.com/dnjrorsut/image/upload/v1561052913/reactcues-assets/Champion_1.png',
    gradient:
      'linear-gradient(90deg, rgba(255, 82, 144, 0.3) 0%, rgba(255, 131, 137, 0.3) 100%)',
    steps: {
      0: {
        backdrop: false,
        description: '',
        isProgressBarHidden: false,
        index: 0,
        legacyStepType: 'flow',
        name: '',
        patternType: 'shorty',
        position: 'bottomLeft',
        published: false,
        sandbox: true,
        skippable: true,
        state: 'DRAFT',
        stepType: 'shorty',
        stepGroupType: StepGroupType.Slideouts,
        steps: {
          0: {
            actionsHidden: true,
            content:
              '<div class="canvas"> <div class="row-container"> <div class="row" style="display: inline-block; width: 100%"> <div class="zone-container" style="display: inline-block; width: 100%; float: left;"> <div class="zone"> <div class="zone-content"> <div class="hero apc-hero" style="min-height:240px;background-size:cover;text-align:center;background-image:url(//res.cloudinary.com/dnjrorsut/image/upload/v1561064463/sample/fenbzgycm1xbhz4z5gfo.png);"><div class="hero-content"><h1></h1></div></div> </div> </div> </div> </div> </div> <div class="row-container"> <div class="row" style="display: inline-block; width: 100%"> <div class="zone-container" style="display: inline-block; width: 100%; float: left;"> <div class="zone"> <div class="zone-content"> <div class="rich-text" style="margin-top:20px;"><style>.rich-text strong{color:inherit !important;}</style><div><h3 style="text-align:center"><span style="color:rgb(124, 124, 124)">Twitter takeover!</span></h3><h2 style="text-align:center"><strong>Spread the word?</strong></h2><p style="text-align:center">Hey there!  We see you recently rated us highly on our satisfaction survey.</p><p style="text-align:center">Could you take a minute to spread the word on Twitter? It helps our business grow. <span style="color:rgb(0, 0, 0)">🌻</span></p></div></div> </div> </div> </div> </div> </div> <div class="row-container"> <div class="row" style="display: inline-block; width: 100%"> <div class="zone-container" style="display: inline-block; width: 100%; float: left;"> <div class="zone"> <div class="zone-content"> <div class="button-wrapper appcues-actions-right appcues-actions-left" style="width:100%;textAlign:center;marginTop:5px;marginBottom:5px;"><style>.button-wrapper>[data-step=prev]::before {content: none} .button-wrapper>.appcues-button[data-step=next]::after {content: none}</style><a class="appcues-button-success appcues-button" data-field-id="b488ecc8-8a5e-49e6-b6e9-afa55d54d1bc" style="text-align:center;padding:8px 18px;" data-step="next">Tweet tweet!</a></div> </div> </div> </div> </div> </div> </div>',
            index: 0,
            isButtonCentered: false,
            nextButtonHidden: true,
            nextText: "Great, I'm all set",
            prevText: 'Back',
            rows: [
              {
                id: '5b241a9b-f8be-4dd1-bcda-2fcfe22b2d9f',
                zones: [
                  {
                    id: 'b6ccd0cb-a9b1-4d00-adbc-4b18c27d4f9b',
                    persistedState: {
                      backgroundType: 'url',
                      content: '<h1></h1>',
                      minHeight: 240,
                      textAlign: 'center',
                      url: '//res.cloudinary.com/dnjrorsut/image/upload/v1561064463/sample/fenbzgycm1xbhz4z5gfo.png',
                      width: 552,
                      zoom: '',
                    },
                    type: 'Hero',
                  },
                ],
              },
              {
                id: 'dc941d9e-ce7c-4256-886e-817327b456b5',
                zones: [
                  {
                    id: '95634c8e-7240-41ee-9379-97da7d4867c9',
                    persistedState: {
                      content:
                        '<h3 style="text-align:center"><span style="color:rgb(124, 124, 124)">Twitter takeover!</span></h3><h2 style="text-align:center"><strong>Spread the word?</strong></h2><p style="text-align:center">Hey there!  We see you recently rated us highly on our satisfaction survey.</p><p style="text-align:center">Could you take a minute to spread the word on Twitter? It helps our business grow. <span style="color:rgb(0, 0, 0)">🌻</span></p>',
                      marginTop: 20,
                    },
                    type: 'RichText',
                  },
                ],
              },
              {
                id: 'b71df402-2e9d-4220-8f71-a4cc874dbfcb',
                zones: [
                  {
                    id: 'b488ecc8-8a5e-49e6-b6e9-afa55d54d1bc',
                    persistedState: {
                      buttonActionType: 'next',
                      buttonText: 'Tweet tweet!',
                      marginBottom: 5,
                      marginTop: 5,
                    },
                    type: 'Button',
                  },
                ],
              },
            ],
            stepNumber: 1,
            stepType: 'components',
          },
        },
      },
    },
  },
];
